import Modal from '../modules/modal.js';
import Rates from '../modules/rates';
import {Counter} from '../modules/counter';
import Widget from '../modules/widget';
import Dropdown from '../modules/dropdown';

export default {
  init() {

    //Single product contact modal
    const PhoneModalProduct = new Modal('.js-phone-modal-product', '.js-phone-modal-button-product');
    PhoneModalProduct.toggleEvent();

    //Single product rates
    const ratesContainer = new Rates('.stars');
    ratesContainer.activeRate();

    //Single product variation
    const counterProductVariation = new Counter('.js-add-to-card-variation');
    counterProductVariation.init();

    //Single product counter
    const counterProductSimple = new Counter('.js-add-to-card-simple');
    counterProductSimple.init();

    // CATEGORY WIDGET ON MOBILE
    const categoryWidget = new Widget('.widget_product_categories', '.js-open-category-widget', 'widget-opened');
    categoryWidget.toggleWidget();

    // CATEGORY WIDGET - SUBCATEGORIES DROPDOWN
    const categoryChildrenDropdown = new Dropdown('.cat-parent', 'subcategory-opened');
    categoryChildrenDropdown.initStateOpen();
    categoryChildrenDropdown.toggleDropdown();
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js